import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodeforcesComponent } from './simple-icons-codeforces.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodeforcesComponent ],
    exports:      [ SimpleIconsCodeforcesComponent ],
    bootstrap:    []
})
export class SimpleIconsCodeforcesModule {}
